/**
 * Types of entities that goals can be assigned to
 */
export enum GoalTargetType {
  Syllabus = 'SYLLABUS',
  User = 'USER',
  Course = 'COURSE',
}
